import { Injectable } from '@angular/core';
import { RestApi } from '../../auth/rest.api';
import { Observable } from 'rxjs';

@Injectable()
export class WorkingTimeSchemaService {
  private _getBaseCalendarOptions = 'api/WorkingTimeSchema/BaseCalendar';
  private _getBaseCalendar = 'api/WorkingTimeSchema/BaseCalendar';
  private _getWorkingTimeSchema = 'api/WorkingTimeSchema';

  constructor(private _restApi: RestApi) {
  }

  public getWorkingTimeSchema(userId: number): Observable<Array<IWorkingTimeSchema>> {
    return this._restApi.get(`${this._getWorkingTimeSchema}/${userId}`);
  }

  public getBaseCalendar(userId: number): Observable<IBaseCalendar> {
    return this._restApi.get(`${this._getBaseCalendar}/${userId}`);
  }

  public getCalendarOptions(): Observable<IBaseCalendar[]> {
    return this._restApi.get(this._getBaseCalendarOptions);
  }

  public updateCalendarBaseByUser(idUser: number, idWorkingTimeSchema: number): Observable<any> {
    return this._restApi.put(`${this._getBaseCalendar}/${idUser}/${idWorkingTimeSchema}`, {});
  }

  public updateCustomCalendar(elements: IWorkingTimeSchema[], idUser: number): Observable<any> {
    return this._restApi.post(`${this._getWorkingTimeSchema}/batch/${idUser}`, { elements });
  }
}
